export const validatePinCode = async (pinCode: string) => {
    try {
        const apiResult: any = await $b2bServer('/ondc/fetchPincodeDetails', { query: { pincode: pinCode } });
        const { status, data } = apiResult;
        // const toast = useToast(); 
        const { $customToast } = useNuxtApp()
        const toast = $customToast
        if(status == 0) {
            toast.add({
                color: "red",
                title: "Invalid Pincode. Please enter a valid Pincode",
                timeout: 2000,
            });
            return { status: 0, data: null };
        } else {
            return { status: 1, data: data[0] };
        }
    } catch(error : any) {
        console.error('Error in PinCode Validation:', error);
        return { status: 0, data: null, error: { code: 500, message: error.message } };
    }
}